module.exports = __webpack_public_path__ + "static/media/siddharth-computer.d549297a.jpg";